// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
import { syncDashboardUrlState } from './urlState';
export function wireViewBar(options) {
    const { getView, setView, getFilter, setFilter, setSearchQuery, markGraphDirty, render } = options;
    document.querySelectorAll('input[name="view"]').forEach((radio) => {
        radio.addEventListener('change', () => {
            const input = radio;
            if (!input.checked)
                return;
            setView(input.value);
            _applyViewVisibility(getView());
            syncDashboardUrlState(getView(), getFilter());
            render();
        });
    });
    const filterSelect = document.getElementById('filter-select');
    if (filterSelect) {
        filterSelect.addEventListener('change', (e) => {
            const next = e.target.value;
            setFilter(next);
            markGraphDirty();
            syncDashboardUrlState(getView(), getFilter());
            render();
        });
    }
    const nameSearchInput = document.getElementById('name-search');
    if (nameSearchInput) {
        nameSearchInput.addEventListener('input', () => {
            setSearchQuery(nameSearchInput.value);
            markGraphDirty();
            render();
        });
    }
    const initialView = getView();
    const viewRadio = document.querySelector(`input[name="view"][value="${initialView}"]`);
    if (viewRadio) {
        viewRadio.checked = true;
    }
    if (filterSelect) {
        filterSelect.value = getFilter();
    }
    _applyViewVisibility(initialView);
    syncDashboardUrlState(getView(), getFilter());
}
function _applyViewVisibility(view) {
    const leftPane = document.getElementById('left');
    const rightPane = document.getElementById('right');
    if (leftPane) {
        leftPane.style.display = view === 'table' ? '' : 'none';
    }
    if (rightPane) {
        rightPane.style.display = view === 'graph' ? '' : 'none';
    }
}
//# sourceMappingURL=viewBar.js.map